import React from 'react';
import { useLocation } from 'react-router-dom';

export const EMBED_PATH_PREFIX = '/embed/';

export function useIsEmbed(): boolean {
  return useLocation().pathname.startsWith(EMBED_PATH_PREFIX);
}

// A page framed on a club's own site brings no site chrome of ours.
export function HideInEmbed({ children }: { children: React.ReactNode }): JSX.Element | null {
  return useIsEmbed() ? null : <>{children}</>;
}
